import { ca } from '@cian/analytics';

export function trackMortgageBrokerBannerClick() {
  ca('eventSite', {
    action: 'Click',
    category: 'Listing',
    label: 'e2eMortgage_banner',
    name: 'oldevent',
  });
}

export function trackMortgageBrokerBannerShow() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Listing',
    label: 'e2eMortgage_banner',
    name: 'oldevent',
  });
}
